var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"page-header"},[_c('div',[_vm._t("default")],2),_c('div',{staticClass:"actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }